/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "ngx-app",
  template: `<nb-layout>
    <nb-layout-column> <router-outlet></router-outlet> </nb-layout-column>,
  </nb-layout> `,
})
export class AppComponent implements OnInit {
  constructor /* private analytics: AnalyticsService,
    private seoService: SeoService */() {}

  ngOnInit(): void {
    /* this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges(); */
  }
}
